import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import React from 'react';

import { CustomFormulaPop } from '.';

import SchemaError from 'components/global/errors/SchemaError';
import { SmartImage } from 'components/global/SmartImage';
import { RICH_TEXT_OPTIONS } from 'consts/contentful';
import type { CustomFormulaEntry } from 'schema';
import { desktopOnly, mobileOnly } from 'styles/mixins/displayMobileDesktop';

export const ContentfulCustomFormula = (props: CustomFormulaEntry) => {
  if (props._type === 'schemaError') {
    return <SchemaError {...props} />;
  }

  const { title, price, valueProp, theme, mobileImage, desktopImage, ...rest } =
    props;

  return (
    <CustomFormulaPop
      mobileImage={
        <SmartImage {...mobileImage} css={[mobileOnly('block', 'mdUp')]} />
      }
      desktopImage={<SmartImage {...desktopImage} css={[desktopOnly()]} />}
      title={documentToReactComponents(title, RICH_TEXT_OPTIONS)}
      price={price && documentToReactComponents(price, RICH_TEXT_OPTIONS)}
      valueProp={
        valueProp && documentToReactComponents(valueProp, RICH_TEXT_OPTIONS)
      }
      theme={theme === 'primary' ? theme : 'secondary'}
      {...rest}
    />
  );
};
